module.exports = {"dashboard_drawer":{"welcome_user":["Bienvenue, <strong>${name}</strong>","Welcome <strong>${name}</strong>"],"mon_espace":["Mon espace","My member area"],"button_signout":["Déconnexion","Sign out"],"button_back_home":["Retour à l'accueil","Back to home page"],"menu_item_profile":["Mon profil","My profile"],"menu_item_events":["Mes événements","My events"],"menu_item_schools":["Mes écoles","My schools"]}}


//////////////////
// WEBPACK FOOTER
// ./src/features/Dashboard/translations/translations_drawer.json
// module id = 1616
// module chunks = 0